import { Header } from "./header";
import { Footer } from "./footer";
import { Outlet } from "react-router-dom";

export function Layout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="container py-8 flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}